import React, { useState } from 'react';
import cx from 'classnames';
import * as Icon from 'react-feather';

import styles from '../BookSearch.module.scss';

const visibleSchemeCount = 4;

const ReadingSchemeCarousel = ({ schemes, onSelectScheme }) => {
    const [startIndex, setStartIndex] = useState(0);
    const canScroll = schemes.length > visibleSchemeCount;

    const visibleSchemes = [];

    if (canScroll) {
        for (let i = 0; i < visibleSchemeCount; i++) {
            const schemeIndex = (startIndex + i) % schemes.length;
            visibleSchemes.push(schemes[schemeIndex]);
        }
    } else {
        visibleSchemes.push(...schemes);
    }

    const showPreviousSchemes = () => {
        setStartIndex(currentIndex => currentIndex === 0 ? schemes.length - 1 : currentIndex - 1);
    }

    const showNextSchemes = () => {
        setStartIndex(currentIndex => currentIndex === schemes.length - 1 ? 0 : currentIndex + 1);
    }

    return (
        <div className={styles.readingSchemes}>
            <button type="button" className={cx(styles.schemeArrow, styles.schemeArrowLeft)} aria-label="Previous reading schemes" onClick={showPreviousSchemes} disabled={!canScroll}>
                <Icon.ChevronLeft size="28" />
            </button>
            <div className={styles.schemeList}>
                {visibleSchemes.map(scheme => (
                    <button type="button" className={styles.schemeCard} onClick={() => onSelectScheme(scheme)} key={scheme.id}>
                        <img src={scheme.iconUrl} alt="" className={styles.schemeIcon} />
                        <span>{scheme.name}</span>
                        <Icon.ChevronRight size="26" className={styles.schemeCardArrow} />
                    </button>
                ))}
            </div>
            <button type="button" className={cx(styles.schemeArrow, styles.schemeArrowRight)} aria-label="Next reading schemes" onClick={showNextSchemes} disabled={!canScroll}>
                <Icon.ChevronRight size="28" />
            </button>
        </div>
    )
}

export default ReadingSchemeCarousel;
